import React from 'react';

const formatDate = (timestamp) => {
  const date = new Date(timestamp);
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0'); // January is 0!
  const yy = String(date.getFullYear()).slice(-2);
  const hh = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  return `${dd}/${mm}/${yy} ${hh}:${min}`;
};

const LearningWidget = ({
  learningStartTime,
  learningEndTime,
  setLearningStartTime,
  setLearningEndTime,
}) => {
  const now = Date.now();
  const remainingDuration = Math.max(0, learningEndTime - now);
  const durationMs = Math.max(0, learningEndTime - learningStartTime);
  const durationDays = Math.floor(durationMs / (1000 * 60 * 60 * 24));
  const durationHours = Math.floor((durationMs / (1000 * 60 * 60)) % 24);
  const remainingDays = Math.floor(remainingDuration / (1000 * 60 * 60 * 24));
  const remainingHours = Math.floor((remainingDuration / (1000 * 60 * 60)) % 24);

  const canLearn = learningStartTime === 0 && learningEndTime === 0;
  const canReset = now > learningEndTime;
  const canStop = remainingDuration > 0;

  const handleLearn = () => {
    const start = Date.now();
    const end = start + 14 * 24 * 60 * 60 * 1000; // 14 days
    setLearningStartTime(start);
    setLearningEndTime(end);
  };

  const handleReset = () => {
    setLearningStartTime(0);
    setLearningEndTime(0);
  };

  const bgColor = remainingDuration > 0 ? '#d4f8d4' : '#f0f0f0';

  return (
    <div
      style={{
        border: '2px solid #ccc',
        padding: '1em',
        borderRadius: '8px',
        backgroundColor: bgColor,
        maxWidth: '300px',
      }}
    >
      <div><strong>Learning Start:</strong> {learningStartTime ? formatDate(learningStartTime) : '—'}</div>
      <div><strong>Learning End:</strong> {learningEndTime ? formatDate(learningEndTime) : '—'}</div>
      <div style={{ marginTop: '0.5em' }}><strong>Duration:</strong> {durationDays} days and {durationHours} hours</div>
      <div><strong>Remaining:</strong> {remainingDays} days and {remainingHours} hours</div>

      <div style={{ marginTop: '1em', display: 'flex', gap: '0.5em' }}>
        <button
          onClick={handleLearn}
          disabled={!canLearn}
          style={{ opacity: canLearn ? 1 : 0.5 }}
        >
          Start Learning
        </button>
        <button
          onClick={handleReset}
          disabled={!canReset}
          style={{ opacity: canReset ? 1 : 0.5 }}
        >
          Reset
        </button>
        <button
          onClick={handleReset}
          disabled={!canStop}
          style={{ opacity: canStop ? 1 : 0.5 }}
        >
          Stop
        </button>
      </div>
    </div>
  );
};

export default LearningWidget;
